/**
 * Environment variables
 */
export const Env = {
  NODE_ENV: process.env.NODE_ENV,
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  MSW_ENABLED: process.env.REACT_APP_MSW_ENABLED,
  URL_PREFIX: process.env.REACT_APP_URL_PREFIX,
  QRCODE_URL: process.env.REACT_APP_QRCODE_URL,
  PDF_URL: process.env.REACT_APP_PDF_URL,
  Word_URL: process.env.REACT_APP_Word_URL,
  Excel_URL: process.env.REACT_APP_Excel_URL,
  EXE_URL: process.env.REACT_APP_EXE_URL,

  isProd() {
    return this.NODE_ENV === 'production'
  },
  isDev() {
    return this.NODE_ENV === 'development'
  },
  isTest() {
    return this.NODE_ENV === 'test'
  },
  isMswEnabled() {
    return this.MSW_ENABLED === 'true'
  },
}

export default Env
